import { useCallback, useState } from 'react'
import { useHistory } from 'react-router'

import { useHasRole } from 'auth/hooks'
import { INTERNAL_ADMIN } from 'civic-champs-shared/auth/utils/permissions'
import useGetOrganization from 'volunteering/organizations/hooks/useGetOrganization'
import useManageOrganization from 'volunteering/organizations/hooks/useManageOrganization'

const useJumpToChampionProfile = () => {
  const isInternalAdmin = useHasRole(INTERNAL_ADMIN)

  const [getOrganization] = useGetOrganization()
  const manageOrganization = useManageOrganization()
  const history = useHistory() //TODO we probably should upgrade react-router to get access to `useNavigate()`

  const [ready, setReady] = useState<boolean>(true)

  const jumpToChampionProfile = useCallback(
    async (organizationId: number, personId: number) => {
      // just in case...  TODO should probably move to manageOrganization() that's what's being protected here
      if (!isInternalAdmin) throw new Error('Must be an Internal Admin to jump to champion profile!')

      setReady(false)
      try {
        const organization = await getOrganization(organizationId)
        manageOrganization(organization)
        history.push(`/champion/${personId}`)
      } finally {
        setReady(true)
      }
    },
    [isInternalAdmin, getOrganization, manageOrganization, history],
  )

  return { jumpToChampionProfile, ready }
}

export default useJumpToChampionProfile
